import { ref, remove, set } from "firebase/database";
import { auth, database } from "../../../Utils/firebase";
import GetUserDataFirebase from "./GetUserDataFirebase";
import { version } from "react";
import { detectBrowser } from "../Session/AddSession";

const AddDeletedUserDataInFirebase = async (state, dispatch, userId, Authentication_Data, deleteReason) => {
    if ((!state?.USERID || state?.USERID == null) && !userId) return null;

    const USERID = state?.USERID || userId;
    const browserName = detectBrowser(navigator.userAgent);
    const deviceName = detectBrowser(navigator.userAgent || '');


    try {
        // Reference to the user's profile node
        const userRef = ref(database, `invoiceGenerator/deletedUsers/${userId}`);

        // User profile data to store
        const userProfile = {
            socialId: Authentication_Data?.uid || "",
            name: Authentication_Data?.name || "",
            email: Authentication_Data?.email || "",
            phone: Authentication_Data?.contact || "",
            uid: Authentication_Data?.user_uid || "",
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            metaDetails: {
                platform: 'website',
                Type: deviceName
            }

        };
        const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

        const userData = {
            createdBy: actorName,
            createdById: state?.USERID || null,
            updatedBy: actorName,
            createdById: state?.USERID || null,
            ...userProfile,
            deleteReason: deleteReason,
            deletedDate: new Date().getTime().toString(),
        };

        // Save or overwrite the user data
        await set(userRef, userData);

        return { success: true, message: "User profile deleted successfully!" };
    } catch (error) {
        console.error("Firebase Error:", error);
        return { success: false, message: error.message || "Failed to save user data" };
    }
};

export default AddDeletedUserDataInFirebase;
